(() => {
  const key = 'biolevita.saved-products.v1';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const write = (items) => { try { localStorage.setItem(key, JSON.stringify(items)); } catch {} };
  const drawer = document.getElementById('BioWishlist');
  const render = () => {
    const items = read();
    document.querySelectorAll('[data-bio-save]').forEach((button) => {
      const saved = items.some((item) => item.id === button.dataset.productId);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${button.dataset.title} ${saved ? 'from' : 'to'} saved items`);
    });
    const list = drawer?.querySelector('[data-bio-wishlist-items]');
    if (!list) return;
    list.replaceChildren();
    drawer.querySelector('[data-bio-wishlist-empty]').hidden = items.length > 0;
    items.forEach((item) => {
      const row = document.createElement('div'); row.className = 'bio-wishlist__item';
      const link = document.createElement('a'); link.href = item.url;
      if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; link.append(img); }
      const details = document.createElement('div');
      const title = document.createElement('a'); title.href = item.url; title.textContent = item.title;
      const price = document.createElement('small'); price.textContent = item.price;
      details.append(title, price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.setAttribute('aria-label', `Remove ${item.title}`);
      remove.addEventListener('click', () => { write(read().filter((saved) => saved.id !== item.id)); render(); });
      row.append(link, details, remove); list.append(row);
    });
  };
  document.addEventListener('click', (event) => {
    const save = event.target.closest('[data-bio-save]');
    if (save) {
      const id = save.dataset.productId;
      const items = read(); const exists = items.some((item) => item.id === id);
      write(exists ? items.filter((item) => item.id !== id) : [...items, { id, url: save.dataset.url, title: save.dataset.title, image: save.dataset.image, price: save.dataset.price }]);
      render(); return;
    }
    const toggle = event.target.closest('[data-bio-wishlist-toggle]');
    if (toggle && drawer) { drawer.hidden = false; toggle.setAttribute('aria-expanded', 'true'); drawer.querySelector('[data-bio-wishlist-close]')?.focus(); render(); return; }
    if (event.target.closest('[data-bio-wishlist-close]') || event.target === drawer) { if (drawer) drawer.hidden = true; document.querySelector('[data-bio-wishlist-toggle]')?.setAttribute('aria-expanded', 'false'); }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer && !drawer.hidden) { drawer.hidden = true; document.querySelector('[data-bio-wishlist-toggle]')?.setAttribute('aria-expanded', 'false'); } });
  document.addEventListener('shopify:section:load', render);
  render();
})();
